import React, { Component } from 'react'
import Cookies from 'js-cookie'
import Modal from './utility/Modal'

class AgeVerification extends Component {
  constructor(props) {
    super(props)

    this.state = {
      visible: false
    }
  }

  componentDidMount() {
    const isBot = window.navigator?.userAgent
      ? window.navigator.userAgent.includes('bot')
      : false

    this.setState({
      visible: Cookies.get('ageVerification') !== '1' && !isBot
    })
  }

  onCloseClick() {
    Cookies.set('ageVerification', '1', { expires: 30 * 6 })
    this.setState({
      visible: false
    })
  }

  render() {
    if (!this.state.visible) {
      return null
    }

    return (
      <Modal
        visible={this.state.visible}
        onClose={this.onCloseClick.bind(this)}
        header={<h3>Doujin.sexy is adults only website!</h3>}
        footer={
          <div className="inner">
            <div className="text-center bold mb-3">
              To enter Doujin.sexy you must be 18 or older
            </div>
            <button
              onClick={this.onCloseClick.bind(this)}
              className="btn btn-primary btn-block"
            >
              I am over 18.
            </button>
          </div>
        }
        scrollable={true}
      >
        Doujin.sexy is strictly limited to those over 18 or of legal age in your
        jurisdiction, whichever is greater.
        <div className="mt-3 mb-3">
          One of our core goals is to help parents restrict access to
          Doujin.sexy for minors, so we have ensured that Doujin.sexy is, and
          remains, fully compliant with the RTA (Restricted to Adults) code.
          This means that all access to the site can be blocked by simple
          parental control tools. It is important that responsible parents and
          guardians take the necessary steps to prevent minors from accessing
          unsuitable content online, especially age-restricted content.
        </div>
        <div className="mt-3">
          Anyone with a minor in their household or under their supervision
          should implement basic parental control protections, including
          computer hardware and device settings, software installation, or ISP
          filtering services, to block your minors from accessing inappropriate
          content.
        </div>
      </Modal>
    )
  }
}

export default AgeVerification
